import { axios } from '../util/axios'

const API_ENDPOINT = '/v1/accounts/recovery/captcha'

export default (email, abTests, captchaToken) =>
  axios
    .post(
      API_ENDPOINT,
      { email },
      {
        headers: {
          'X-TestAB-Groups': abTests || '',
          'X-Accounts-Recovery-Recaptcha': captchaToken,
        },
        withCredentials: true,
      }
    )
    .then(response => response.data)
